import * as React from 'react';
import cx from 'classnames';
import format from 'date-fns/format';
import { ChatMessageSingleTick, ChatMessageDoubleTick, ChatMessageDoubleTickRead, ChatMessagePendingIcon } from 'components/Icons/Icons';
import styles from './MessageMeta.css';
export var MessageMetaTheme;
(function (MessageMetaTheme) {
    MessageMetaTheme["LIGHT"] = "LIGHT";
    MessageMetaTheme["DARK"] = "DARK";
})(MessageMetaTheme || (MessageMetaTheme = {}));
const statusIndicatorDark = '#000';
const statusIndicatorLight = '#FFF';
class MessageMeta extends React.Component {
    render() {
        const { theme, messageStatus, isReceivedMessage, timeStamp, lastReadMessageTimestamp, lastDeliveredMessageTimestamp, className } = this.props;
        const statusIndicatorColor = theme && theme === MessageMetaTheme.DARK ? statusIndicatorDark : statusIndicatorLight;
        const statusIndicatorIconParam = {
            fill: statusIndicatorColor,
            className: styles['message-delivery-status']
        };
        return (<div className={cx(styles['message-meta'], className)}>
				<div className={cx(styles['message-time'], {
            [styles['message-time-dark']]: theme === MessageMetaTheme.DARK || isReceivedMessage
        })}>
					{format(new Date(timeStamp), 'h:mm a')}
				</div>
				{!isReceivedMessage &&
            (messageStatus === 'PENDING'
                ? ChatMessagePendingIcon(statusIndicatorIconParam)
                : lastReadMessageTimestamp && timeStamp <= lastReadMessageTimestamp
                    ? ChatMessageDoubleTickRead(statusIndicatorIconParam)
                    : lastDeliveredMessageTimestamp && timeStamp <= lastDeliveredMessageTimestamp
                        ? ChatMessageDoubleTick(statusIndicatorIconParam)
                        : ChatMessageSingleTick(statusIndicatorIconParam))}
			</div>);
    }
}
export default MessageMeta;
